import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
    {
        path: '/',
        redirect: {
            name: 'Home'
        }
    },

    {
        path: '/home',
        name: 'Home',
        component: () => import('./views/Home.vue'),
        meta: {
            title: 'Home',
            key: 'home'
        }
    },

    {
        path: '/articles',
        name: 'Articles',
        component: () => import('./views/Articles.vue'),
        meta: {
            title: 'Articles',
            key: 'articles'
        }
    },

    // {
    //     path: '/portfolio/:category(web|apps|business)',
    //     name: 'PortfolioCategory',
    //     component: () => import('./views/ArticleDetail.vue'),
    //     meta: {
    //         title: 'Showroom',
    //         key: 'portfolio-category'
    //     }
    // },

    
    // Visualización indexada de todos los elementos de tipo "portfolio-category"
    {
        path: '/portfolio/apps',
        name: 'PortfolioApps',
        component: () => import('./views/Portfolio.vue'),
        meta: {
            title: 'Portafolio de aplicaciones moviles',
            key: 'apps-portfolio',
            presentation: 'portfolio_apps_eyebrow'
        }
    },

    {
        path: '/portfolio/web',
        name: 'PortfolioWeb',
        component: () => import('./views/Portfolio.vue'),
        meta: {
            title: 'Portafolio web',
            key: 'web-portfolio',
            presentation: 'portfolio_web_eyebrow'
        }
    },

    {
        path: '/portfolio/business',
        name: 'PortfolioBusiness',
        component: () => import('./views/Portfolio.vue'),
        meta: {
            title: 'Portafolio de negocios',
            key: 'business-portfolio',
            presentation: 'portfolio_business_eyebrow'
        }
    },

    // Visualización detallada de un proyecto específico de tipo "portfolio"(portfolio-category)
    {
        path: '/portfolio/project/:id/:title?',
        name: 'PortfolioDetail',
        component: () => import('./views/Article.vue'),
        meta: { }
    },

    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: () => import('./views/PrivacyPolicy.vue'),
        meta: {
            title: 'Privacy Policy',
            key: 'privacy-policy',
            hideContact: true
        }
    },

    {
        path: '/terms-and-conditions',
        name: 'TermsConditions',
        component: () => import('./views/TermsConditions.vue'),
        meta: {
            title: 'Terms & Conditions',
            key: 'terms-and-conditions',
            hideContact: true
        }
    },

    {
        path: '/cookies',
        name: 'Cookies',
        component: () => import('./views/Cookies.vue'),
        meta: {
            title: 'Cookies Policy',
            key: 'cookies',
            hideContact: true
        }
    },

    {
        path: '/articles/:hash',
        name: 'Article',
        component: () => import('./views/Article.vue'),
        meta: {
            title: 'Article',
            key: 'article-detail'
        }
    },

    {
        path: '/pages/:hash?',
        name: 'Page',
        component: () => import('./views/Article.vue'),
        meta: {
            title: 'Page',
            key: 'page'
        }
    },

    {
        path: '*',
        name: 'NotFound',
        component: () => import('./views/NotFound.vue'),
        meta: {
            title: 'Not Found',
            key: 'not-found'
        }
    }
];

export default new Router({
    mode: 'history',
    base: process.env.VUE_APP_PUBLIC_PATH || '/',
    routes
});